import { selectCurrentEpisode } from './selectors';
import {
  updateCurrentEpisode as updateEpisode,
  updateCurrentPodcast as updatePodcast,
  updatePlayerRate as updateRate,
} from './slice';
import { getPodcastEpisodeFromEpisodeId } from '../../../api/mobileApi';
import { RootState } from '../../../app/reducer';
import { AppThunk } from '../../../app/store';
import { PlayerService } from '../../../components/Player/PlayerService';
import { PodcastEpisodeModel, PodcastModel } from '../../../models/Podcast.model';
import { selectPodcastTabName } from '../../appconfig/store/selectors';
import { selectPodcastFeedData } from '../../podcast/store/selectors';
import {
  selectEpisodeProgress,
  selectPodcastReadList,
} from '../../podcastList/store/selectors';
import {
  getResumePosition,
  removeEpisodeFromReadList,
} from '../../podcastList/store/slice';

const resolveResumePosition = (
  state: RootState,
  episode: PodcastEpisodeModel,
): number => {
  const progress = selectEpisodeProgress(episode.podcastId, episode.id)(state);
  const isRead = selectPodcastReadList(state).some(
    ([pId, eId]) => pId === episode.podcastId && eId === episode.id,
  );
  return getResumePosition(progress, isRead);
};

export const updateCurrentPodcast =
  (episode: PodcastEpisodeModel, podcast: PodcastModel): AppThunk =>
  dispatch => {
    dispatch(updateEpisode(episode));
    dispatch(updatePodcast(podcast));
  };

export const updateCurrentEpisode =
  (episode: PodcastEpisodeModel): AppThunk =>
  dispatch => {
    dispatch(updateEpisode(episode));
  };

/**
 * Sets the given episode as current and starts playback, resuming from the
 * saved listening position when there is one (APPS-2159).
 */
export const startEpisodePlayback =
  (episode: PodcastEpisodeModel): AppThunk<Promise<void>> =>
  async (dispatch, getState) => {
    dispatch(updateEpisode(episode));
    const startPosition = resolveResumePosition(getState(), episode);
    /* Relaunching an episode clears its "read" flag so it looks unread again. */
    dispatch(
      removeEpisodeFromReadList({ podcastId: episode.podcastId, episodeId: episode.id }),
    );
    await PlayerService.addPodcastEpisode(episode, startPosition);
  };

/**
 */
export const playEpisodeById =
  (podcastId: string, episodeId: string, tab?: string): AppThunk<Promise<void>> =>
  async (dispatch, getState) => {
    const podcastUrl = selectCurrentEpisode(getState()).podcastUrl;

    let episode = selectPodcastFeedData(podcastUrl)(getState())?.data.find(
      e => e.id === episodeId,
    );

    if (!episode) {
      const resolvedTab = tab ?? selectPodcastTabName(podcastUrl)(getState()) ?? 'tab1';
      episode = await getPodcastEpisodeFromEpisodeId(resolvedTab, podcastId, episodeId);
    }

    dispatch(updateEpisode(episode));
    const startPosition = resolveResumePosition(getState(), episode);
    /* Relaunching an episode clears its "read" flag so it looks unread again. */
    dispatch(
      removeEpisodeFromReadList({ podcastId: episode.podcastId, episodeId: episode.id }),
    );
    await PlayerService.addPodcastEpisode(episode, startPosition);
  };

export const updatePlayerRate =
  (rate: number): AppThunk =>
  dispatch => {
    dispatch(updateRate(rate));
    PlayerService.setRate(rate);
  };
